export default __webpack_public_path__ + "static/media/exit.489c2add.svg";